import { OtpReasonTypes } from '@/app/auth/shared/auth-enums';
import { MixpanelTrackerService, MixpanelTimerKeys } from '@/app/core/analytics';
import { UserService } from '@/app/core/services/user.service';
import { RequestUserOTPResultResponseResult } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, inject, output } from '@angular/core';

@Component({
  selector: 'app-confirm-otp',
  imports: [SharedModule],
  templateUrl: './confirm-otp.component.html',
  styleUrl: './confirm-otp.component.less',
})
export class ConfirmOtpComponent {
  isVisible: boolean = false;

  emitOtpModal = output<number | null>();

  email: string = '';
  phone: string = '';

  otpValue: number | undefined;

  private readonly _mixpanelTracker = inject(MixpanelTrackerService);

  constructor(private _userService: UserService) {
    this.otpValue = undefined;
  }

  show(
    otpReasonType: OtpReasonTypes,
    newPhoneCode: string | undefined = undefined,
    newEmail: string | undefined = undefined,
    newPhoneNumber: string | undefined = undefined
  ): void {
    this.isVisible = true;
    this.otpValue = undefined;
    this.email = '';
    this.phone = '';
    if (otpReasonType != undefined && otpReasonType != OtpReasonTypes.VerifyAccount.valueOf()) {
      if (otpReasonType == OtpReasonTypes.VerifyEmail) {
        this.email = newEmail ?? '';
      }
      if (otpReasonType == OtpReasonTypes.VerifyPhone) {
        this.phone = newPhoneNumber ?? '';
      }
      this._userService
        .requestOtp(otpReasonType.valueOf(), newPhoneCode, this.phone, this.email)
        .subscribe((res: RequestUserOTPResultResponseResult) => {
          if (res.isSuccess) {
            try {
              if (otpReasonType == OtpReasonTypes.VerifyEmail) {
                this._mixpanelTracker.startTimer(MixpanelTimerKeys.CODE_ENTRY);
                this._mixpanelTracker.trackAccountContactChangingStarted({
                  'changing contact': 'Email',
                });
              } else if (otpReasonType == OtpReasonTypes.VerifyPhone) {
                this._mixpanelTracker.startTimer(MixpanelTimerKeys.CODE_ENTRY);
                this._mixpanelTracker.trackAccountContactChangingStarted({
                  'changing contact': 'Phone number',
                });
              }
            } catch {
              // Analytics must never break the OTP flow
            }
          } else {
            this.closeModal();
          }
        });
    }
  }

  confirmOtp() {
    if (this.otpValue) {
      this.emitOtpModal.emit(this.otpValue);
      this.isVisible = false;
    }
  }

  closeModal() {
    this.emitOtpModal.emit(null);
    this.isVisible = false;
  }
}
